import { createModeratorApiClient } from '../utils/apiClient';

const mod = createModeratorApiClient();

export const importSourcesApi = {
  /** @param {File} file */
  uploadDocument: (file, config = {}) => {
    const form = new FormData();
    form.append('file', file);
    return mod.post('/import/documents/upload', form, {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data', ...config.headers },
    });
  },

  /** @param {number} documentId */
  getDocument: (documentId, config = {}) =>
    mod.get(`/import/documents/${documentId}`, config),

  /** @param {number} documentId */
  confirmDocument: (documentId, config = {}) =>
    mod.post(`/import/documents/${documentId}/confirm`, null, config),

  /** @param {number} documentId */
  downloadDocument: (documentId, config = {}) =>
    mod.get(`/import/documents/${documentId}/download`, {
      ...config,
      responseType: 'blob',
    }),

  /** @param {File} file */
  uploadUrlList: (file, config = {}) => {
    const form = new FormData();
    form.append('file', file);
    return mod.post('/import/url-lists/upload', form, {
      ...config,
      headers: { 'Content-Type': 'multipart/form-data', ...config.headers },
    });
  },

  /**
   * @param {number} batchId
   * @param {{ sheet_name: string; header_row?: number; url_column?: string }} body
   */
  previewUrlList: (batchId, body, config = {}) =>
    mod.post(`/import/url-lists/${batchId}/preview`, body, config),

  /** @param {number} batchId */
  validateUrlList: (batchId, config = {}) =>
    mod.post(`/import/url-lists/${batchId}/validate`, null, config),

  /** @param {number} batchId */
  confirmUrlList: (batchId, config = {}) =>
    mod.post(`/import/url-lists/${batchId}/confirm`, null, config),

  /** @param {number} batchId */
  getUrlListBatch: (batchId, config = {}) =>
    mod.get(`/import/url-lists/${batchId}`, config),
};
